export var EOfferAnalyticsDealType;
(function (EOfferAnalyticsDealType) {
  EOfferAnalyticsDealType["RentDay"] = "rentDay";
  EOfferAnalyticsDealType["RentLong"] = "rentLong";
  EOfferAnalyticsDealType["Sale"] = "sale";
})(EOfferAnalyticsDealType || (EOfferAnalyticsDealType = {}));
export var EOfferAnalyticsObjectType;
(function (EOfferAnalyticsObjectType) {
  EOfferAnalyticsObjectType["Commercial"] = "commercial";
  EOfferAnalyticsObjectType["FlatNew"] = "flatNew";
  EOfferAnalyticsObjectType["FlatNewDev"] = "flatNewDev";
  EOfferAnalyticsObjectType["FlatOld"] = "flatOld";
  EOfferAnalyticsObjectType["Suburban"] = "suburban";
})(EOfferAnalyticsObjectType || (EOfferAnalyticsObjectType = {}));
export var EOfferAnalyticsVariant;
(function (EOfferAnalyticsVariant) {
  EOfferAnalyticsVariant["Auction"] = "auction";
  EOfferAnalyticsVariant["Calltracking"] = "calltracking";
  EOfferAnalyticsVariant["Demand"] = "demand";
  EOfferAnalyticsVariant["Free"] = "free";
  EOfferAnalyticsVariant["Highlight"] = "highlight";
  EOfferAnalyticsVariant["Paid"] = "paid";
  EOfferAnalyticsVariant["Premium"] = "premium";
  EOfferAnalyticsVariant["Top3"] = "top3";
})(EOfferAnalyticsVariant || (EOfferAnalyticsVariant = {}));